<section  id="clients" >
  <div class="container">

    <header class="section-header">
      <h3>Our Recent Activities</h3>
  
    </header>

    <owl-carousel-o [options]="customOptions">
      <ng-container *ngFor="let item of activities;">
        <ng-template carouselSlide [id]="item.$key">
          <img [src]="item.imgUrl" alt="Recent Activities"  class="mx-auto">
        </ng-template>
      </ng-container>
    </owl-carousel-o>
  
</div></section>